import {login, logout, permission, getInfo, checkLogin, getCompangModules, verifyPassword} from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { localSave, localRemove, localRead, getQueryString } from '@/utils/tools'
import { addSysRouter } from '@/router/permission'
import router from '@/router'
import store from '@/store'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

export function saveLocalInfo(result, label) {
  const isBy = result.isBy
  const { displayName, imageAddress, status, userName, companyId, email, phone, userToken, businessIdCompany, businessIdUser, top, language, id, companyCode,thirdPartyId } = result.userVo
  let userInfo = {
    displayName,
    imageAddress,
    status,
    userName,
    companyId,
    email,
    phone,
    userToken,
    businessIdCompany,
    businessIdUser,
    top,
    id,
    companyCode,
    thirdPartyId,
    language,
    isBy: isBy
  }
  localSave(label + '_sys_userInfo', JSON.stringify(userInfo))
}

export function saveRouterLabel(result, model) {
  let codeArr = JSON.parse(localRead('sysCode'))
  let total_label
  for (let i in codeArr) {
    if (codeArr[i].id == model) {
      total_label = codeArr[i].code
      //存储全局的系统标识
      window.SITE_CONFIG['routerLabel'] = total_label
      //存储token
      localRemove('sysToken')
      setToken(result.token, total_label)
      //存储本地用户信息
      saveLocalInfo(result, total_label)
      return
    }
  }
}

export function saveButtonControls() {
  permission(2).then(response => {
    const { result } = response
    let buttonsControl = result
    localSave(
      window.SITE_CONFIG['routerLabel'] + '_buttons',
      JSON.stringify(buttonsControl)
    )
  })
}

export function changeMenu(routerLabel) {
  permission(1).then(res => {
    const { result } = res
    let getRouter = result
    localSave(
      routerLabel + '_router',
      JSON.stringify(getRouter)
    )
    addSysRouter(getRouter, routerLabel)
    // 客服模块：登录后加载客服档案，供 request.js 注入 X-Agent-Id
    try {
      const csUi = JSON.parse(localRead(routerLabel + '_sys_userInfo') || '{}')
      if (csUi.userName) store.dispatch('customerService/fetchAgentInfo', csUi.userName)
    } catch (e) { /* 忽略 */ }
    router.push({ path: '/business/dashboard/list', query: { label: routerLabel } })
    if (this&&this.$route) {
      this.$store.dispatch('tagsView/delAllViews', this.$route)
    }
  })
}
const actions = {
  // user login password verify
  verifyPassword({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      verifyPassword({ username: username.trim(), password: password }).then(response => {
        const { result } = response
        if (result)
          resolve(result);
        else reject('unknown reason');
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user login
  login({ commit }, userInfo) {
    const { username, password, otp } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, model: '-1', otp }).then(response => {
        const { result } = response
        localSave('userId', result.userVo.id)
        localSave('model', result.model)
        if (result.model != -1) {
          window.SITE_CONFIG['routerLabel'] = result.code
          setToken(result.token, result.code)
          saveLocalInfo(result, result.code)
          changeMenu(result.code)
          saveButtonControls()
        } else {
          localSave('sysToken', result.token)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeSysterm({ commit }, model) {
    return new Promise((resolve, reject) => {
      checkLogin({ model: model }).then(response => {
        const { result } = response
        // 存储全局的系统标识
        saveRouterLabel(result, model)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo({ Authorization: state.token }).then(response => {
        const { result } = response

        if (!result) {
          reject('Verification failed, please Login again.')
        }

        const { roles, displayName, imageAddress } = result.userVo

        commit('SET_ROLES', roles)
        commit('SET_NAME', displayName)
        commit('SET_AVATAR', imageAddress)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        if (window.location.href.indexOf('label') != -1) {

          let labelRouter = getQueryString('label')
          //清除缓存
          removeToken(labelRouter) // must remove  token  first
          localRemove(labelRouter + '_router')
          localRemove(labelRouter + '_sys_userInfo')
          localRemove(labelRouter + '_menus')
          localRemove(labelRouter + '_buttons')
          localRemove(labelRouter + '_tabViews')
        }
        // resetRouter()
        localRemove('language')
        commit('RESET_STATE')
        // In order to make the cached page re-rendered
        dispatch('tagsView/delAllViews', null, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      if (window.location.href.indexOf('label') != -1) {
        let labelRouter = getQueryString('label')
        removeToken(labelRouter) // must remove  token  first
        commit('RESET_STATE')
        commit('SET_ROLES', [])
      }
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
